export default {
  model: {
    eventCategory: 'Event category',
    hotWord: 'Hot word',
    message: 'Message',
    topic: 'Topic',
    post: 'Post',
    eventBooking: 'Event booking',
    product: 'Wine',
    productRating: 'Wine rating',
    member: 'Member',
    provenance: 'Provenance',
    country: 'Country',
    province: 'Province',
    city: 'City',
    merchantCategory: 'Winery category',
    adminUsersRole: 'Admin user',
    adminUser: 'Admin user',
    role: 'Role',
    user: 'User',
    banner: 'Banner',
    application: 'Application',
    page: 'Page',
    appConfig: 'App config',
    setting: 'Setting',
    productCategory: 'Wine category',
    merchant: 'Winery',
    question: 'Question',
    option: 'Option',
    customPage: 'Custom page',
    activeStorageBlob: 'Resource',
    actsAsTaggableOnTag: 'Tag',
  },
  eventCategory: {
    applicationId: 'Application',
    name: 'Name',
    application: 'Application',
  },
  hotWord: {
    name: 'Name',
    position: 'Position',
    applicationId: 'Application',
  },
  message: {
    content: 'Content',
    productId: 'Product',
    userId: 'User',
    isRead: 'Is read',
    product: 'Wine',
    user: 'User',
  },
  topic: {
    name: 'Name',
    isTop: 'Is top',
  },
  post: {
    title: 'Title',
    likesCount: 'Likes count',
    publishedAt: 'Published at',
    miniProgramPath: 'Mini program path',
    shareDesc: 'Share description',
    publisherType: 'Publisher type',
    publisherId: 'Publisher',
    publisher: 'Publisher',
    shareImage: 'Share image',
    posterImage: 'Poster image',
    infographic: 'Infographic',
    medium: 'Medium',
    topics: 'Topics',
    topicIds: 'Topic ids',
    merchants: 'Merchants',
    merchantIds: 'Merchant ids',
    products: 'Products',
    productIds: 'Product ids',
  },
  eventBooking: {
    eventId: 'Event',
    userId: 'User',
    event: 'Event',
    user: 'User',
  },
  product: {
    colourAndLustre: 'Colour and lustre',
    drinkTemperature: 'Drink temperature',
    enName: 'En name',
    name: 'Name',
    alcoholContent: 'Alcohol content',
    merchantId: 'Merchant',
    productCategoryId: 'Product category',
    productRatingId: 'Product rating',
    likesCount: 'Likes count',
    miniProgramPath: 'Mini program path',
    shareDesc: 'Share description',
    mainImage: 'Main image',
    merchant: 'Winery',
    productCategory: 'Wine category',
    productRating: 'Wine rating',
    description: 'Description',
    tastingNotes: 'Tasting notes',
    shareImage: 'Share image',
    posterImage: 'Poster image',
    backgroundImage: 'Background image',
  },
  productRating: {
    name: 'Name',
  },
  member: {
    email: 'Email',
    name: 'Name',
    wechat: 'Wechat',
    cityId: 'City',
    gender: 'Gender',
    genders: {
      male: 'Male',
      female: 'Female',
    },
    provinceId: 'Province',
    userId: 'User',
    userType: 'Member type',
    userTypes: {
      amateur: 'Amateur',
      practitioner: 'Practitioner',
    },
    birthYear: 'Birth year',
    user: 'User',
    questionaire: 'Questionaire',
    city: 'City',
    province: 'Province',
  },
  provenance: {
    name: 'Name',
    cityIds: 'City ids',
    cities: 'Cities',
  },
  country: {
    iso3: 'Iso3',
    name: 'Name',
  },
  province: {
    name: 'Name',
    countryId: 'Country',
    country: 'Country',
  },
  city: {
    name: 'Name',
    provinceId: 'Province',
    province: 'Province',
  },
  merchantCategory: {
    name: 'Name',
  },
  adminUsersRole: {
    roleId: 'Role',
    adminUserId: 'Admin user',
    applicationId: 'Application',
    merchantId: 'Merchant',
    role: 'Role',
    application: 'Application',
    merchant: 'Winery',
    adminUser: 'Admin user',
  },
  adminUser: {
    email: 'Email',
    name: 'Name',
    phone: 'Phone',
  },
  role: {
    name: 'Name',
    kind: 'Kind',
    kinds: {
      custom: 'Custom',
      super: 'Super',
      application: 'Application',
      merchant: 'Winery',
    },
    customPermissions: 'Custom permissions',
  },
  user: {
    screenName: 'Screen name',
    avatar: 'Avatar',
    member: 'Member',
  },
  banner: {
    target: 'Target',
    position: 'Position',
    pagePosition: 'Page position',
    pagePositions: {
      event: 'Event',
    },
    kind: 'Kind',
    kinds: {
      web_link: 'Web link',
      image: 'Image',
      mp_link: 'Mini program link',
    },
    alt: 'Alt',
    image: 'Image',
  },
  application: {
    name: 'Name',
    desc: 'Desc',
    shareDesc: 'Share description',
    shareTitle: 'Share title',
    expiredAt: 'Expired at',
    wechatApplicationId: 'Wechat application',
    wechatOfficialAccountUrl: 'Wechat official account url',
    wechatApplication: 'Wechat application',
    applicationAdminUsersRoleId: 'Application admin users role',
    shareImage: 'Share image',
    logo: 'Logo',
    homeTopLogo: 'Home top logo',
    homeBottomLeftLogo: 'Home bottom left logo',
    questionaireTopImage: 'Questionaire top image',
    questionaireBackgroundImage: 'Questionaire background image',
    personalCenterBackgroundImage: 'Personal center background image',
    myCardsBackgroundImage: 'My cards background image',
    authorizeState: 'Authorize state',
    creator: 'Creator',
    posterImage: 'Poster image',
  },
  page: {
    slug: 'Slug',
    title: 'Title',
    type: 'Type',
    applicationId: 'Application',
    status: 'Status',
    statuses: {
      draft: 'Draft',
      published: 'Published',
    },
    viewsCount: 'Views count',
    miniProgramPath: 'Mini program path',
    wxacode: 'Wxacode',
    content: 'Content',
  },
  appConfig: {
    extJson: 'Ext json',
    applicationId: 'Application',
  },
  setting: {
  },
  productCategory: {
    name: 'Name',
  },
  merchant: {
    name: 'Name',
    enName: 'En name',
    website: 'Website',
    contact: 'Contact',
    phone: 'Phone',
    email: 'Email',
    wechat: 'Wechat',
    street: 'Street',
    provinceId: 'Province',
    cityId: 'City',
    provenanceId: 'Provenance',
    merchantCategoryId: 'Merchant category',
    longitude: 'Longitude',
    latitude: 'Latitude',
    wineryTour: 'Winery tour',
    likesCount: 'Likes count',
    miniProgramPath: 'Mini program path',
    shareDesc: 'Share description',
    logo: 'Logo',
    province: 'Province',
    city: 'City',
    provenance: 'Provenance',
    merchantCategory: 'Winery category',
    shareImage: 'Share image',
    posterImage: 'Poster image',
    introduction: 'Introduction',
    images: 'Images',
  },
  question: {
    content: 'Content',
    kind: 'Kind',
    kinds: {
      single_choice: 'Single choice',
      multiple_choice: 'Multiple choice',
    },
    position: 'Position',
    enabled: 'Enabled',
    options: 'Options',
  },
  option: {
    content: 'Content',
    position: 'Position',
  },
  customPage: {
    title: 'Title',
    slug: 'Slug',
    default: 'Default',
    miniProgramPath: 'Mini program path',
    formalCustomPageId: 'Formal custom page',
    canRollbackData: 'Can rollback data',
    configs: 'Configs',
  },
  activeStorageBlob: {
  },
  actsAsTaggableOnTag: {
    name: 'Name',
  },
}
